<template>
  <div>
    <div class="rigt_navbar" id="content">
      <ul class="breadcrambs display_non">
        <li>B2B</li>
        <li><i class="fa fa-chevron-right"></i></li>
        <li><a href="#">Publish Lots</a></li>
      </ul>
      <h3 class="main_header display_non">Publish Lots</h3>
      <div class="check_table">
        <div class="check_tablw stow_scroll">
          <div class="table_colmw table_bordr">
            <div class="table_cols1"><h4 class="table_head1">Sl. no</h4></div>
            <div class="table_cols3">
              <h4 class="table_head1">Display Name</h4>
            </div>
            <div class="table_cols2"><h4 class="table_head1">MRP</h4></div>
            <div class="table_cols2"><h4 class="table_head1">Grade</h4></div>
            <div class="table_cols2">
              <h4 class="table_head1">Floor Price</h4>
            </div>
            <div class="table_cols2"><h4 class="table_head1">Location</h4></div>
            <div class="table_cols2">
              <h4 class="table_head1">Buy Now Price</h4>
            </div>
            <div class="table_cols1"><h4 class="table_head1">Action</h4></div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>1</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span
                  >Washing Machine || Panasonic || Functional || Bangalore</span
                >
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>45000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Mixed</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>11000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Bangalore</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>30000.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>2</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span
                  >Hard Disks & Others Multibrand || Mixed || Bangalore</span
                >
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>4030.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Mixed</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>1501.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Bangalore</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>3586.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>3</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span>Television || Panasonic || Functional || Bangalore</span>
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>60000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Refurbished Very Good</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>15000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Bangalore</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>30000.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>4</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span>Speaker || Panasonic || Functional || Bangalore</span>
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>45000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Mixed</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>15000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Bangalore</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>30000.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>5</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span
                  >Electric Iron || Phillips || Functional || Bangalore</span
                >
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>120000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Refurbished Very Good</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>10000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Bangalore</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>48000.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>6</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span>Mobile || Panasonic || Functional || Bangalore</span>
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>90000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Refurbished Very Good</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>10000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Bangalore</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>48000.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>7</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span>Decommission IT assets-Laptops 15</span>
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>15000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Defective</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>4580.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Bangalore</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>10000.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>8</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span>Washing Machine || Panasonic || Functional || Delhi</span>
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>45000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Mixed</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>11000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Delhi</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>30000.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>9</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span>Hard Disks & Others Multibrand || Mixed || Mumbai</span>
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>4030.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Mixed</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>1501.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Mumbai</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>3586.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>10</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span>Television || LG || Mixed || Delhi</span>
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>60000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Mixed</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>15000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Delhi</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>30000.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>11</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span>Speaker || Panasonic || Mixed || Bangalore</span>
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>45000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Mixed</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>15000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Bangalore</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>30000.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>12</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span>Electric Iron || Phillips || Functional || Delhi</span>
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>120000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Refurbished Very Good</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>10000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Delhi</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>48000.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>13</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span>Mobile || Panasonic || Functional || Mumbai</span>
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>90000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Refurbished Very Good</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>10000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Mumbai</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>48000.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
          <div class="table_colmw table_bordr table_poup">
            <div class="table_cols1">
              <h4 class="table_head1"><span>14</span></h4>
            </div>
            <div class="table_cols3">
              <h4 class="table_head1">
                <span>Decommission IT assets-Laptops 12</span>
              </h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>15000.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Defective</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>4580.0</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>Bangalore</span></h4>
            </div>
            <div class="table_cols2">
              <h4 class="table_head1"><span>10000.0</span></h4>
            </div>
            <div class="table_cols1">
              <h4 class="table_head1">
                <span><button class="qc_p_buttn2">Publish</button></span>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
